import styled from 'styled-components';
import pallette from "../pallette.css";

export const Paper = styled.div`
    width : 100%;
    padding : 5vh;
    box-shadow : 3px 3px 10px #00000029;
    background-color : ${pallette.WHITE};
    border-radius : 10px 10px 10px 10px;
`